import React from "react";

import { Box, Container, Typography } from "@material-ui/core";

import { useTranslation } from "react-i18next";

import { AvailableOrderTypes } from "api/types/enums";
import makeStyles from "hooks/makeStyles";
import useBusiness from "hooks/useBusiness";
import useCart from "hooks/useCart";
import { formatMoney } from "utility/formatMoney";

const useStyles = makeStyles(theme => ({
	root: {
		padding: 0,
		paddingTop: theme.spacing(2),
		display: "flex",
		flex: 1,
		flexDirection: "column",
		height: "calc(100vh - 95px)", // not great..
		position: "relative",
		[theme.breakpoints.up(480)]: {
			height: "auto"
		}
	},
	title: {
		textAlign: "left",
		textTransform: "uppercase",
		fontWeight: 500,
		fontSize: 16,
		letterSpacing: "0.38px",
		alignContent: "center",
		alignItems: "center"
	},
	titleBlock: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center"
	},
	icon: {
		height: 12,
		width: 12,
		marginRight: theme.spacing(1),
		fill: "#fff",
		[theme.breakpoints.up(480)]: {
			fill: theme.palette.text.primary
		}
	},
	change: {
		border: 0,
		padding: 0,
		fontSize: 12,
		textTransform: "uppercase",
		fontWeight: 500,
		width: "auto",
		minWidth: "auto",
		color: "#fff"
	},
	items: {
		marginBottom: theme.spacing(2)
	},
	item: {
		marginLeft: theme.spacing(2),
		marginTop: theme.spacing(2),
		marginRight: theme.spacing(2),
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between"
	},
	itemTitle: {
		color: "#f2f2f2",
		textTransform: "uppercase",
		fontSize: "12px",
		letterSpacing: "0.38px"
	},
	itemTitleChecked: {
		color: "#fff"
	},
	titleRow: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center"
	},
	dataRow: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		paddingBottom: theme.spacing(1)
	},
	data: {
		display: "inline-block",
		fontSize: 14,
		textTransform: "uppercase"
	},
	total: {
		fontSize: 16,
		textTransform: "uppercase",
		fontWeight: 500,
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		paddingBottom: theme.spacing(1)
	},
	discountText: {
		color: theme.palette.secondary.dark
	}
}));

const OrderTotal = () => {
	const classes = useStyles();
	const { t } = useTranslation();
	const {
		orderType,
		cartTotalCents,
		discount,
		taxCents,
		grandTotalCents,
		getTipCents,
		tipPercentage,
		percentOff
	} = useCart();
	const { business } = useBusiness();
	const { taxRate } = business;

	return (
		<Container className={classes.root}>
			<Box className={classes.titleRow}>
				<Box className={classes.titleBlock}>
					<Typography className={classes.title}>{t("yourOrder")}</Typography>
				</Box>
			</Box>

			<Box className={classes.dataRow}>
				<Typography className={classes.data}>{t("foodBeverageTotal")}</Typography>
				<Typography className={classes.data}>{formatMoney(cartTotalCents)}</Typography>
			</Box>

			{discount !== null && discount > 0 && (
				<Box className={`${classes.dataRow} ${classes.discountText}`}>
					<Typography className={classes.data}>{t("discountPercentOff", { percentOff }).toUpperCase()}</Typography>
					<Typography className={classes.data}>- {formatMoney(discount)}</Typography>
				</Box>
			)}

			{orderType?.orderType !== AvailableOrderTypes.delivery ? null : (
				<Box className={classes.dataRow}>
					<Typography className={classes.data}>{t("deliveryFee")}</Typography>
					<Typography className={classes.data}>{formatMoney(orderType.priceCents || 0)}</Typography>
				</Box>
			)}

			<Box className={classes.dataRow}>
				<Typography className={classes.data}>{t("tax", { taxRate })}</Typography>
				<Typography className={classes.data}>{formatMoney(taxCents)}</Typography>
			</Box>

			<Box className={classes.dataRow}>
				<Typography className={classes.data}>
					{t("tip")} {tipPercentage ? `(${tipPercentage}%)` : ""}
				</Typography>
				<Typography className={classes.data}>{formatMoney(getTipCents())}</Typography>
			</Box>

			{/* <Box className={classes.data}>{t("courrierTip")}</Box> */}
			<Box className={classes.dataRow}>
				<Typography className={classes.total}>{t("total")}</Typography>
				<Typography className={classes.total}>{formatMoney(grandTotalCents)}</Typography>
			</Box>
		</Container>
	);
};

export default OrderTotal;
